export default [
  {
    name: 'getBlackListPage',
    method: 'POST',
    path: '/vue/account-blackList/account-page'
  },
  {
    name: 'delBlackList',
    method: 'POST',
    path: '/vue/account-blackList/account-delBlackList'
  },
  {
    name: 'addBlackList',
    method: 'POST',
    path: '/vue/account-blackList/account-addBlackList'
  },
];
